import { render, staticRenderFns } from "./TagsUnimed.vue?vue&type=template&id=e7c8513a"
import script from "./TagsUnimed.vue?vue&type=script&lang=js"
export * from "./TagsUnimed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports